import React from "react";
import { Card } from "../../../../shared/card/card.tsx";
import { useWeeklyTimesheet } from "../../../../../hooks/use-timesheet-summary.ts";
import styles from "./timesheet-summary-card.module.css";
import { FileText } from "lucide-react";
import { Link } from "react-router-dom";

const TimesheetSummaryCard = () => {
  const { data, loading } = useWeeklyTimesheet();
  const draftDays =
    data?.days?.filter(
      (day: { status?: string }) => day.status === "DRAFT"
    ) ?? [];

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  return (
    <Card variant="default" padding="5xl" className={styles.cardContainer}>
      {/* Header */}
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between ">
          <h5 className="heading-sm">Timesheet Summary</h5>
          <span className="badge--warning">
            {draftDays.length} Pending
          </span>
        </div>
        <div className="sub-heading-sm">
          {loading ? (
            <span className="text-muted">Loading...</span>
          ) : (
            <>
              Week of {formatDate(data?.weekStart)} -{" "}
              {formatDate(data?.weekEnd)}
            </>
          )}
        </div>
      </div>

      {/* Content */}

      <div className={styles.cardSection}>
        {/* Total */}
        <div className={`info-card ${styles.totalBox}`}>
          <div>
            <p className={`${styles.totalLabel} mb-1`}>Total Hours This Week</p>
            <p className={`${styles.totalValue} mb-0`}>
              {data?.totalHours || 0} hrs
            </p>
          </div>
          <div
            className={`d-flex justify-content-center align-items-center ${styles.iconBg}`}
          >
            <FileText className={`icon-accent`} size={18} />
          </div>
        </div>

        {/* Billable */}
        {/* <div className={styles.rowItem}>
          <div className={styles.rowLeft}>
            <span className={styles.dotPrimary}></span>
            <span className="sub-heading-md">Billable Hours</span>
          </div>
          <span className={styles.valueText}>
            {data?.billableHours || 0} hrs
          </span>
        </div>

        <div className={styles.rowItem}>
          <div className={styles.rowLeft}>
            <span className={styles.dotMuted}></span>
            <span className="sub-heading-md">Non-Billable</span>
          </div>
          <span className={styles.valueText}>
            {data?.nonBillableHours || 0} hrs
          </span>
        </div> */}

        {/* Days */}
        <div className={styles.divider}>
          <div className={styles.scrollContainer}>
            {draftDays.length === 0 && !loading ? (
              <p className="sub-heading-sm text-muted mb-0">
                No draft timesheet has been recorded for this week.
              </p>
            ) : (
              draftDays.map((day: { date: string }) => (
                <div key={day.date} className={styles.dayRow}>
                  <span className="sub-heading-md">
                    {new Date(day.date).toLocaleDateString("en-US", {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                    })}
                  </span>

                  <span className="badge--danger">Draft</span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Button */}
        <Link
          to="/dashboard/timesheets"
          className={`${styles.submitBtn} btn-xl d-flex justify-content-center gap-2`}
        >
          <FileText size={18} />
          <span>Submit Timesheets</span>
        </Link>
      </div>
    </Card>
  );
};

export default TimesheetSummaryCard;
